import useId from '../utils/useId';
import * as React from 'react';
export const weroSvg = React.forwardRef(function weroSvgInner(props, ref) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FFF48D',
      d: 'M0 .003h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.37 16.343c0-1.745 1.214-3.336 3.31-3.336 2.106 0 3.32 1.591 3.32 3.336 0 1.746-1.214 3.338-3.32 3.338-2.095 0-3.31-1.592-3.31-3.338Zm4.787 0c0-.84-.541-1.618-1.476-1.618-.926 0-1.476.778-1.476 1.618 0 .842.55 1.62 1.476 1.62.935 0 1.476-.778 1.476-1.62Zm-6.076 1.24c.7-.407 1.118-1.185 1.118-2.044 0-1.275-.9-2.36-2.297-2.36h-2.935v6.33h1.817V17.89h.34l1.04 1.619h2.14l-1.223-1.926Zm-1.546-1.15h-.751v-1.79h.76c.49 0 .804.407.804.896 0 .488-.324.895-.813.895ZM9.673 13.171l-1.09 3.774-1.064-3.774H6.072l-1.073 3.774-1.08-3.774H2l2.197 6.32h1.578l1.02-3.44 1.012 3.44h1.587l2.197-6.32H9.673Zm4.667 4.776h-.004c-.68 0-1.156-.42-1.361-.976h4.617c.038-.21.057-.423.057-.64 0-1.741-1.21-3.329-3.309-3.33v1.715c.684.001 1.155.42 1.358.975h-4.611c-.037.21-.056.424-.056.64 0 1.742 1.212 3.331 3.305 3.331h.004v-1.715Z',
      fill: '#1D1C1C',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.335 19.662c.071 0 .141-.003.21-.006a3.47 3.47 0 0 0 1.156-.254 3.047 3.047 0 0 0 1.537-1.398c.15-.279.258-.58.327-.895H15.64c-.04.084-.085.164-.138.24a1.438 1.438 0 0 1-.25.275 1.345 1.345 0 0 1-.707.308c-.067.01-.137.015-.21.015a1.38 1.38 0 0 1-1.033-.438l-1.251 1.295c.556.526 1.327.858 2.283.858Z',
      fill: `url(#bi_wero__a_${id_0})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.335 13c-1.774 0-2.915 1.143-3.221 2.553h1.918c.23-.486.681-.838 1.303-.838.496 0 .881.22 1.133.551l1.262-1.306c-.564-.585-1.374-.96-2.395-.96Z',
      fill: `url(#bi_wero__b_${id_1})`,
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_wero__a_${id_0}`,
          x1: 16.596,
          y1: 15.937,
          x2: 13.646,
          y2: 19.468,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.024,
          stopColor: '#1D1C1C',
          stopOpacity: 0,
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.676,
          stopColor: '#1D1C1C',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_wero__b_${id_1}`,
          x1: 11.643,
          y1: 16.751,
          x2: 14.653,
          y2: 13.843,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.024,
          stopColor: '#1D1C1C',
          stopOpacity: 0,
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.676,
          stopColor: '#1D1C1C',
        }),
      ),
    ),
  );
});
weroSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var wero = {
  category: 'brand',
  colorable: false,
  name: 'wero',
  svg: weroSvg,
};
